import { FaExclamationCircle } from "react-icons/fa";

const ErrorMessage: React.FC<{
  id?: string;
  message: string;
  className?: string;
}> = ({ id = "", message, className = "" }) => (
  <span className={`flex items-center gap-1 text-xs text-red-600 ${className}`}>
    <FaExclamationCircle />
    <p id={id}>{message}</p>
  </span>
);

export default ErrorMessage;
